import TrancheField from './TrancheField';

export default TrancheField;
